import React from 'react';

function Incorrect({ question, onClick }) {
  let txtClass = '';
  const val = question.choices[question.correct];
  if (val.length > 16) {
    txtClass = 'length-lg length-17';
  } else if (val.length > 15) {
    txtClass = 'length-lg length-16';
  } else if (val.length > 14) {
    txtClass = 'length-lg length-15';
  } else if (val.length > 13) {
    txtClass = 'length-lg length-14';
  } else if (val.length > 12) {
    txtClass = 'length-lg length-13';
  } else if (val.length > 11) {
    txtClass = 'length-lg length-12';
  } else if (val.length > 10) {
    txtClass = 'length-lg length-11';
  } else if (val.length > 9) {
    txtClass = 'length-lg length-10';
  }
  return (
    <div className="answerContent">
      <div className="answerInner">
        <p className="answerTitle">
          <img src={'assets/img/txt-incorrect.png'} alt="不正解" className="txtIncorrect" />
        </p>
        <div className="answerBox">
          <div className="answerRow">
            <p className="left">
              <img src={'assets/img/txt-answer.png'} alt="正解は" className="txtAnswer" />
            </p>
            <div className="questionChoiceBtns">
              <div className="questionChoiceBtn questionIncorrectBtn">
                <div className="questionChoiceBtnInner">
                  <span className="number">
                    <img src={'assets/img/number-choice-' + Number(question.correct + 1) + '.png'} alt={Number(question.correct + 1)} className="offBtn" />
                  </span>
                  <div className={txtClass + ' txt'}>
                    <span className="txtInner" dangerouslySetInnerHTML={{ __html: val }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={'answerComment--' + Number(question.number) + ' ' + 'answerComment'}>
            <div dangerouslySetInnerHTML={{ __html: question.comment }} />
          </div>
        </div>
        <button onTouchStart={() => {}} className="questionBtn questionNextBtn" onClick={onClick}>
          <img src={'assets/img/btn-next.png'} alt="次の問題へ" />
        </button>
      </div>
    </div>
  );
}

export default Incorrect;
